import { FC, useState, useEffect } from "react";

import { useSound } from "../../../../hooks";

interface InitalChatMessageProp {
    displayAfter: number;
    normalText: string;
    boldText: string;
}

const InitalChatMessage: FC<InitalChatMessageProp> = (props) => {
    const {normalText, boldText, displayAfter} = props;
    const [showMessage, setShowMessage] = useState<boolean>(false);
    const {playSound} = useSound();

    useEffect(() => {
        const showMessageTimeout =  setTimeout(() => {
            setShowMessage(true)
        }, displayAfter);
        
        return () => clearTimeout(showMessageTimeout);
    }, [displayAfter]);
    
    useEffect(() => {
		const timeout = setTimeout(() => {
			playSound("/sounds/MessageReceived2.mp3");
		}, displayAfter);

		return () => clearTimeout(timeout)
  
	},[displayAfter, playSound]);

    if (!showMessage)
        return (null)

    return (
        <div className="message_row">
            <div className="first_chat_message">
                <div className="chat_message_message_wrapper" >
                    <div className="chat_message_senders_message">
                        <p>
                            {" "}
                            {normalText}<span className="bold">{boldText}</span>
                        </p>
                       
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InitalChatMessage;